module.exports = __webpack_public_path__ + "img/penguin_winter.9e1eb444.svg";